import SelectFilters from './SelectFilters';
import './SelectFilters.scss';

export default SelectFilters;